import { render, staticRenderFns } from "./indemnityRatio.vue?vue&type=template&id=9c159260&scoped=true&"
import script from "./indemnityRatio.vue?vue&type=script&lang=js&"
export * from "./indemnityRatio.vue?vue&type=script&lang=js&"
import style0 from "./indemnityRatio.vue?vue&type=style&index=0&id=9c159260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c159260",
  null
  
)

export default component.exports